import { render, staticRenderFns } from "./BrowseMode.vue?vue&type=template&id=55980234&"
import script from "./BrowseMode.vue?vue&type=script&lang=ts&"
export * from "./BrowseMode.vue?vue&type=script&lang=ts&"
import style0 from "./BrowseMode.vue?vue&type=style&index=0&id=55980234&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports